import { call, put, takeEvery, select } from "redux-saga/effects";
import { getBankDetailsForUser } from "../bank-details/actions";
import {
  setBankCorespondents,
  addBankCorespondent,
  updateBankCorespondent,
  deleteBankCorespondent,
  bankCorespondentLoading,
} from "./actions";
import {
  getBankCorrespondents,
  postBankCorrespondents,
  patchBankCorrespondent,
  deleteBankCorrespondent,
} from "../../helpers/jwt_helper.js";
import {
  GET_BANK_CORESPONDENTS,
  ADD_BANK_CORESPONDENT,
  UPDATE_BANK_CORESPONDENT,
  DELETE_BANK_CORESPONDENT,
} from "./actionTypes";

import {
  showErrorMessage,
  getErrorMessage,
  showSuccessMessage,
} from "../../helpers/utils";

function* onGetBankCorespondents({ payload: data }) {
  try {
    yield put(bankCorespondentLoading());
    let response = yield call(getBankCorrespondents, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      search: data.search,
      bank_details: data?.bank_details,
    });
    response = {
      ...data,
      ...response,
      results: response.results.map(i => ({
        ...i,
      })),
    };
    yield put(setBankCorespondents(response));
    yield put(bankCorespondentLoading());
  } catch (error) {
    yield put(bankCorespondentLoading());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onAddBankCorespondent({ payload: data }) {
  try {
    yield put(bankCorespondentLoading());
    yield call(postBankCorrespondents, data);
    yield call(onGetBankCorespondents, {
      payload: yield select(state => state.BankCorespondent.data),
    });
    yield put(getBankDetailsForUser(data.user))
    yield put(bankCorespondentLoading());
  } catch (error) {
    yield put(bankCorespondentLoading());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onPatchBankCorespondent({ payload: { id, data, user } }) {
  try {
    yield put(bankCorespondentLoading());
    yield call(patchBankCorrespondent, id, data);
    yield call(onGetBankCorespondents, {
      payload: yield select(state => state.BankCorespondent.data),
    });
    yield put(getBankDetailsForUser(user))
    yield put(bankCorespondentLoading());
    showSuccessMessage(`Updating bank information has been successfully`);
  } catch (error) {
    yield put(bankCorespondentLoading());
    showErrorMessage(getErrorMessage(error));
  }
}

function* onDeleteBankCorespondent({ payload: { id, user }}) {
  try {
    yield put(bankCorespondentLoading());
    yield call(deleteBankCorrespondent, id);
    yield call(onGetBankCorespondents, {
      payload: yield select(state => state.BankCorespondent.data),
    });
    yield put(getBankDetailsForUser(user))
    yield put(bankCorespondentLoading());
    showSuccessMessage(`Bank details has been cleared`);
  } catch (error) {
    yield put(bankCorespondentLoading());
    showErrorMessage(getErrorMessage(error));
  }
}

function* bankCorespondentsSaga() {
  yield takeEvery(GET_BANK_CORESPONDENTS, onGetBankCorespondents);
  yield takeEvery(ADD_BANK_CORESPONDENT, onAddBankCorespondent);
  yield takeEvery(UPDATE_BANK_CORESPONDENT, onPatchBankCorespondent);
  yield takeEvery(DELETE_BANK_CORESPONDENT, onDeleteBankCorespondent);
}

export default bankCorespondentsSaga;
